// src/components/recording/LevelTile.jsx
import React from "react";
import { Link } from "react-router-dom";

/**
 * GlassPanel tile used on the Level Selection page.
 *
 * Props:
 * - to: router path
 * - title: heading
 * - desc: short paragraph
 * - meta: string[] of small chips (e.g., "~5 min", "No device needed")
 * - disabled?: boolean
 */
export default function LevelTile({
  to,
  title,
  desc,
  meta = [],
  disabled = false,
  cta,
}) {
  const body = (
    <div className="outlined-container">
      <h2 className="subtitle-text text-primary">{title}</h2>
      <p className="text-sm text-typography leading-relaxed">{desc}</p>

      {meta?.length ? (
        <ul className="mt-1 flex flex-wrap gap-2">
          {meta.map((m, i) => (
            <li
              key={i}
              className="text-xs px-2 py-1 rounded-full border border-greyscale-3 "
            >
              {m}
            </li>
          ))}
        </ul>
      ) : null}

      <div className="mt-auto text-sm font-medium text-primary w-full text-end">
        <span className="inline-flex items-center gap-1">
          {cta}
          <svg
            className="size-4 transition-transform group-hover:translate-x-0.5"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M7.293 14.707a1 1 0 0 1 0-1.414L10.586 10 7.293 6.707A1 1 0 0 1 8.707 5.293l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0Z" />
          </svg>
        </span>
      </div>
    </div>
  );

  if (disabled) {
    return (
      <div
        aria-disabled="true"
        className="opacity-60 pointer-events-none"
        title="Coming soon"
      >
        {body}
      </div>
    );
  }

  return (
    <Link
      to={to}
      replace
      className="block focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 rounded-2xl"
    >
      {body}
    </Link>
  );
}
